import { Stack, Typography } from "@mui/material";
import React from "react";
import { CardData, ScrollCards } from ".";

const ScrollCardsExamples: React.FC = () => {
  const cardsData: CardData[] = [
    {
      title: "Card 1",
      description: "This is the description for card 1.",
      iconName: "AwardIcon",
    },
    {
      title: "Card 2",
      description: "This is the description for card 2.",
      iconName: "BellIcon",
    },
  ];

  return (
    <Stack>
      <Typography variant="h2" textAlign="center">
        Scroll Cards
      </Typography>

      <ScrollCards cardsData={cardsData} />
    </Stack>
  );
};

export default ScrollCardsExamples;
